import { getSnapshot, types } from 'mobx-state-tree';
import { BASE_LIMIT_PER_PAGE, BASE_OFFSET } from '../constants';
import { CrystalConnectionStatusMST } from './crystal';

export const FiltersModel = types
  .model('Filters', {
    limit: types.optional(types.number, BASE_LIMIT_PER_PAGE),
    offset: types.optional(types.number, BASE_OFFSET),
    connection_status: types.optional(
      types.maybeNull(CrystalConnectionStatusMST),
      null
    ),
    id: types.optional(types.string, ''),
  })
  .views((self) => ({
    get listFilters() {
      const { id, ...rest } = getSnapshot(self);

      const filters = rest;

      if (filters.connection_status === null) {
        // @ts-ignore
        delete filters.connection_status;
      }

      return rest;
    },

    get idFilter() {
      const { id } = getSnapshot(self);

      return id;
    },
  }))
  .actions((self) => ({
    changeField<K extends keyof typeof self>(field: K, value: typeof self[K]) {
      self[field] = value;
    },
  }));
